export default __webpack_public_path__ + "static/media/client-3.18c21778.png";